<template>
  <div>
    <div class="sms-module-header">
      {{ kpiName }} ({{ kpiExplain }})
      <div class="air-type el-select-wrapper" v-if="airTypeOption">
        <el-select v-model="airType" placeholder="请选择" @change="onAirTypeChange">
          <el-option v-for="item in airTypeOption" :key="item.code" :value="item.code" :label="item.name"></el-option>
        </el-select>
      </div>
    </div>
    <div class="warn-chart-box">
      <div ref="chart" class="chart">
        <el-empty description="暂无数据"></el-empty>
      </div>
    </div>
    <el-dialog title="明细列表" :visible.sync="eventDetail.visible" width="95%">
      <MandatoryList ref="detail" :company="eventDetail.company" :year="eventDetail.year"
                     :month="eventDetail.month" :insecurity="eventDetail.insecurity" :eventReason="eventDetail.eventReason"></MandatoryList>
    </el-dialog>
  </div>
</template>

<script>
import {getRequest} from "../../../utils/request";
import MandatoryList from "../../activity/MandatoryList";

export default {
  props: {
    kpiCode: String,
    year: Number,
    defaultAirType: String,
  },
  data() {
    return {
      company: null,
      kpiName: null,
      kpiExplain: null,
      //机型
      airType: null,
      //类目轴
      xAxisData: null,
      //实际值
      actualValue: null,
      //红黄蓝告警值
      redWarning: null,
      yellowWarning: null,
      blueWarning: null,
      //机型下拉选（也作为是否区分机型的标志）
      airTypeOption: null,
      chart: null,
      //实际值series名称
      actualValueSeriesName: null,
      //警告id
      alertId: null,
      //飞行品质系统地址
      qarHost: process.env.qarHost,
      /**
       * 下面几个属性都是和图表重新加载相关的，机型变化，数据从前端本地数据中取，要重新构建option
       */
      //图表数据
      chartData: null,
      //放大倍数（当单位不同时，放大倍数不同，例如百分率，所有数据放大100倍）
      multiple: null,
      //不安全事件明细
      eventDetail: {
        visible: false,
        month: null,
        year: null,
        company: null,
        insecurity: null,
        eventReason: null,
      },
    }
  },
  mounted() {
    //预先加载当前航司，图表点击时需要用
    this.getCompany();
    this.buildChart();
  },
  watch: {
    kpiCode() {
      this.buildChart();
    },
    year() {
      this.buildChart();
    },
  },
  methods: {
    buildChart() {
      getRequest('/risk/dwkpi/getListByKpiCode', {
        kpiCode: this.kpiCode,
        year: this.year
      }, this.$refs.chart).then(res => {
        let data = res.data;
        //无数据场景（仅组件初次加载时有效）
        if (!data || Object.keys(data).length === 0) return

        this.chartData = data;
        //指标名称
        this.kpiName = data.kpiName;
        //指标说明
        this.kpiExplain = data.kpiExplain;
        //度量单位
        let measuringUnit = data.measuringUnit;
        //存储度量单位明文
        this.actualValueSeriesName = "实际值(" + data.measuringUnitText + ")";
        //警告id
        this.alertId = data.alertId;
        //机型下拉选初始化
        if (data.airTypeOption && data.airTypeOption.length > 0) {
          this.airTypeOption = data.airTypeOption.map(item => {
            return {"code": item, "name": item === "ALL" ? "全部" : item}
          });
          //初次加载默认加载第一个机型
          if (this.defaultAirType)
            this.airType = this.defaultAirType;
          else
            //默认加载"全部"，如果不存在"全部"，则加载第1个
            this.airType = this.airTypeOption.some(item => item.code === "ALL") ? "ALL" : this.airTypeOption[0].code;
        } else {
          this.airTypeOption = null;
        }
        //单位不同，图表不同
        let yAxisName;
        //存储放大倍数
        switch (measuringUnit) {
          case "percentage":
            yAxisName = "%";
            this.multiple = 100;
            break
          case "1000timesRte":
          case "10000hourRate":
          case "10000timesRate":
            yAxisName = "‰";
            this.multiple = 1000;
            break
        }
        this.setChartValue();

        this.chart = this.$echarts.init(this.$refs.chart);
        let option = this.getOption();

        //百分率，Y轴显示为百分号
        if (yAxisName) {
          option.yAxis.name = yAxisName;
          option.yAxis.nameTextStyle.align = "right";
        }
        this.chart.setOption(option, true);
        //绑定事件
        this.chart.off("click").on("click", {seriesName: this.actualValueSeriesName}, params => {
          if (data.qarWarnKTimesRate === 'Y') {
            //点击的月份，需要格式化月份：MM
            let prettifyMonth = this.$util.prefixZero(params.data.month, 2);
            let dateId = this.year + "" + prettifyMonth;
            let orgId = this.company.nodeId;
            let alertId = this.alertId;
            let acType = this.airType;
            let url = this.qarHost + "/DAP/rdThird.do?res_id=147677442774731424&paramArr=dateType=<月>::dateId=<" + dateId + ">::orgId=" + orgId + "::acType=" + acType + "::alertId=" + alertId + "::alertType=<ALL>::kpiType=<QCL>";
            console.log("QAR接口地址：" + url)
            window.open(url)
          } else if (data.eventNorm === '是') {
            this.eventDetail.year = params.data.year;
            this.eventDetail.month = params.data.month;
            this.eventDetail.insecurity = params.data.insecurity;
            this.eventDetail.company = this.company.code;
            this.eventDetail.visible = true;
            this.eventDetail.eventReason = params.data.eventReason;
          } else {
            return;
          }
        });
      })
    },
    getCompany() {
      getRequest("/company/current", {})
        .then(res => {
          this.company = res.data;
        })
    },
    onAirTypeChange() {
      this.setChartValue();
      this.chart.setOption(this.getOption());
    },
    setChartValue() {
      this.xAxisData = [];
      this.redWarning = [];
      this.yellowWarning = [];
      this.blueWarning = [];
      this.target = [];
      this.actualValue = [];

      let monthMap = this.chartData.airTypeData[this.airTypeOption ? this.airType : "NONE"];
      let currentYear = new Date().getFullYear();
      let currentMonth = new Date().getMonth() + 1;

      for (let year = this.year - 2; year <= this.year; year++) {
        for (let month = 1; month <= 12; month++) {
          let monthKey = year + "-" + month;
          this.xAxisData.push(monthKey);

          let redWarning = 0;
          let yellowWarning = 0;
          let blueWarning = 0;
          let target = 0;
          let actualValue = 0;
          let actualValueChangeRemark;

          if (monthMap) {
            //月份值不存在时，值设为null，图表线条截断
            redWarning = null;
            yellowWarning = null;
            blueWarning = null;
            target = null;
            actualValue = null;

            if (monthMap[monthKey]) {
              let monthData = monthMap[monthKey];
              redWarning = monthData.redWarning;
              yellowWarning = monthData.yellowWarning;
              blueWarning = monthData.blueWarning;
              target = monthData.target;
              actualValueChangeRemark = monthData.changeDescr;
              //当前年，不能超过当前月
              if (month <= currentMonth || year < currentYear)
                actualValue = monthData.actualValue;
            }
          }
          //赋值
          this.redWarning.push({value: redWarning, month: month});
          this.yellowWarning.push({value: yellowWarning, month: month});
          this.blueWarning.push({value: blueWarning, month: month});
          this.target.push({value: target, month: month});
          this.actualValue.push({
            value: actualValue,
            year: year,
            month: month,
            changeRemark: actualValueChangeRemark,
            insecurity: this.chartData.insecurity,
            eventReason: this.chartData.eventReason
          });
        }
      }
    },
    getOption() {
      return {
        xAxis: {
          data: this.xAxisData,
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#ddd",
            },
          },
          axisLabel: {
            color: "#999999",
            fontSize: 12,
          },
        },
        grid: {
          containLabel: true,
          left: 0,
          right: 0,
          bottom: 0
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
          padding: [5, 10],
          formatter: this.tooltipFormatter
        },
        yAxis: {
          nameTextStyle: {},
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              type: "dashed",
            },
          },
          axisLabel: {
            color: "#999999",
            fontSize: 12,
          },
        },
        legend: {
          itemWidth: 12,
          itemHeight: 12,
        },
        series: [
          {
            name: "红色预警值",
            type: "line",
            symbol: "circle",
            data: this.redWarning,
            itemStyle: {
              color: "#ff0000",
              borderType: "solid"
            },
            lineStyle: {
              color: "#ff0000",
            },
            animationDuration: 1000,
            animationEasing: "quadraticOut",
          },
          {
            name: "黄色预警值",
            type: "line",
            symbol: "circle",
            data: this.yellowWarning,
            itemStyle: {
              color: "#d7bd00",
              borderType: "solid"
            },
            lineStyle: {
              color: "#d7bd00",
            },
            animationDuration: 1000,
            animationEasing: "quadraticOut",
          },
          {
            name: "蓝色预警值",
            type: "line",
            symbol: "circle",
            data: this.blueWarning,
            itemStyle: {
              color: "#6ea2ff",
              borderType: "solid"
            },
            lineStyle: {
              color: "#6ea2ff",
            },
            animationDuration: 1000,
            animationEasing: "quadraticOut",
          },
          {
            name: "目标值",
            type: "line",
            symbol: "circle",
            data: this.target,
            itemStyle: {
              color: "#009140",
              borderType: "solid"
            },
            lineStyle: {
              color: "#009140",
            },
            animationDuration: 1000,
            animationEasing: "quadraticOut",
          },
          {
            name: this.actualValueSeriesName,
            type: "line",
            symbol: "circle",
            data: this.actualValue,
            itemStyle: {
              normal: {
                color: "#1800c8",
                lineStyle: {
                  color: "#1800c8",
                  width: 3,
                },
                areaStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "rgba(24,0,100,0.2)", // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "rgba(24,0,100, 0)", // 100% 处的颜色
                      },
                    ],
                    global: false,
                  },
                },
              },
            },
            animationDuration: 1000,
            animationEasing: "quadraticOut",
          },
        ],
        dataZoom: [
          {
            type: 'inside',
            //固定显示24个月（当前年和前一年）的数据
            minValueSpan: 23,
            maxValueSpan: 23,
            //初次加载时从第25个月（当前年）开始
            startValue: 24,
            //禁止拖拽平移
            moveOnMouseMove: false,
          },
        ],
      };
    },
    /**
     * 生成图片，base64格式
     */
    getDataURL(data) {
      let param = {
        pixelRatio: 2,
        backgroundColor: '#fff'
      };
      if (data) param = data;
      return this.chart.getDataURL(param);
    },
    /**
     * tooltip内容自定义格式化
     */
    tooltipFormatter: params => {
      let htmlStr = '';
      //构建默认数据
      for (let i = 0; i < params.length; i++) {
        let param = params[i];
        let xName = param.name;//x轴的名称
        let seriesName = param.seriesName;//图例名称
        let value = param.value === null || param.value === undefined ? "-" : param.value;//y轴值
        let color = param.color;//图例颜色

        if (i === 0) {
          htmlStr += '<span>' + xName + '</span><br/>';//x轴的名称
        }
        htmlStr += '<div style="margin-top: 3px">';

        // 具体显示的数据【字段名称：seriesName，值：value】
        // 正常显示的数据，走默认
        htmlStr += '<span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:' + color + ';"></span>';
        htmlStr += seriesName + '<span style="float:right;margin-left:20px;font-weight: 900">' + value + '</span>';
        htmlStr += '</div>';
      }
      //追加额外数据
      let actualValueParam = params[params.length - 1];
      let actualValueChangeRemark = actualValueParam.data.changeRemark;
      if (!actualValueChangeRemark) actualValueChangeRemark = "-";
      htmlStr += '<div style="margin-top: 3px">';
      htmlStr += '<span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:#fff;"></span>';
      htmlStr += '变更说明<span style="max-width: 200px;font-weight:900;margin-left:20px;white-space: pre-line;float: right;">' + actualValueChangeRemark + '</span>';
      htmlStr += '</div>';
      return htmlStr;
    }
  },
  components: {
    MandatoryList,
  }
}
</script>

<style scoped lang="less">
.sms-module-header {
  display: flex;
  align-items: center;
  height: 40px;
  font-weight: bold;
}

.air-type {
  width: 110px;
  margin-left: 20px;
}

.chart {
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/achievement/risk/KpiChart.vue